import BonezGame from "./BonezGame"

const componentCoordinates = {
    desktop: { //3840 x 2160
        scale: 1,
        cardScale: 0.85,

        bonezLogo: {
            x: 456,
            y: 168,
            scale: 1,
        },
        potContainer: {
            x: 1828.8,
            y: 203.2,
            scale: 0.8,
        },
        forfeitButton: {
            x: 1117.6,
            y: 203.2,
            scale: 1,
            fontSize: 70,
        },
        howToPlayButton: {
            x: 2540,
            y: 203.2,
            scale: 1,
            fontSize: 70,
        },
        standButton: {
            x: 917.6,
            y: 1991.36,
            scale: 1,
            fontSize: 70,
        },
        endTurnButton: {
            x: 2340,
            y: 1991.36,
            scale: 1,
            fontSize: 70,
        },
        turnTimer: {
            x: 1774.48,
            y: 1147.44,
            scale: 1,
            fontSize: 70,
        },
        statusMessage: {
            x: 1438.96,
            y: 1077.44,
            scale: 1,
        },
        spectatorCount: {
            x: 668.8,
            y: 391.36,
            scale: 0.86,
        },
        emojiMenu: {
            x: 3610,
            y: 1881.36,
            scale: 0.7,
        },
        winModal: {
            x: 1920,
            y: 1080,
            scale: 1,
        },
        opponent: {
            namePanel: {
                x: 2540.28,
                y: 520,
                scale: 1,
            },
            chatIcon: {
                x: 2850.28,
                y: 455,
                scale: 0.25,
            },
            winsText: {
                x: 284.48,
                y: 355.6,
                fontSize: 48,
            },
            playerBoard: {
                x: 1638.96,
                y: 785.8,
                scale: 1.5,
            },
            winsContainer: {
                x: 144.48,
                y: 588.8,
                scale: 1.3
            },
            score: {
                x: 144.48,
                y: 993.92,
                scale: 1,
            },
            cardSlot1: {
                x: 1624,
                y: 482,
                scale: 0.55,
                rotation: Math.PI,
            },
            cardSlot2: {
                x: 1793,
                y: 482,
                scale: 0.55,
                rotation: Math.PI,
            },
            cardSlot3: {
                x: 1962,
                y: 482,
                scale: 0.55,
                rotation: Math.PI,
            },
            cardSlot4: {
                x: 2131,
                y: 482,
                scale: 0.55,
                rotation: Math.PI,
            },
        },
        player: {
            namePanel: {
                x: 2540.28,
                y: 1221.36,
                scale: 1,
            },
            winsText: {
                x: 284.48,
                y: 1879.6,
                fontSize: 48,
            },
            playerBoard: {
                x: 1638.96,
                y: 1509.08,
                scale: 1.5,
            },
            winsContainer: {
                x: 144.48,
                y: 1736.4,
                scale: 1.3
            },
            score: {
                x: 144.48,
                y: 1326.04,
                scale: 1,
            },
            cardSlot1: {
                x: 3173.12,
                y: 785.72,
                scale: 1.35,
            },
            cardSlot2: {
                x: 3597.6,
                y: 785.72,
                scale: 1.35,
            },
            cardSlot3: {
                x: 3173.12,
                y: 1421.32,
                scale: 1.35,
            },
            cardSlot4: {
                x: 3597.6,
                y: 1421.32,
                scale: 1.35,
            },
        }
    },
    desktopSpectator: { //3840 x 2160
        scale: 1,
        cardScale: 0.85,

        potContainer: {
            x: 1788.8,
            y: 183.2,
            scale: 0.8,
        },
        chatIcon: {
            x: 2850.28,
            y: 455,
            scale: 0.25,
        },
        forfeitButton: {
            x: 416,
            y: 183.2,
            scale: 1,
            fontSize: 70,
        },
        howToPlayButton: {
            x: 960,
            y: 183.2,
            scale: 1,
            fontSize: 70,
        },
        turnTimer: {
            x: 1774.48,
            y: 1147.44,
            scale: 1,
            fontSize: 70,
        },
        statusMessage: {
            x: 1438.96,
            y: 1077.44,
            scale: 1,
        },
        playerStatsBackground: {
            x: 3485,
            y: 1116,
            scaleX: 0.64,
            scaleY: 0.97,
        },
        spectatorCount: {
            x: 760,
            y: 1996,
            scale: 1,
        },
        emojiMenu: {
            x: 3000,
            y: 1991.36,
            scale: 0.7,
        },
        winModal: {
            x: 1920,
            y: 1080,
            scale: 1,
        },
        opponent: {
            namePanel: {
                x: 2540.28,
                y: 502.72,
                scale: 1,
            },
            chatIcon: {
                x: 2850.28,
                y: 455,
                scale: 0.25,
            },
            playerStats: {
                x: 3220,
                y: 540,
                scale: 1,
                lineHeightScale: 1,
            },
            winsText: {
                x: 284.48,
                y: 355.6,
                fontSize: 48,
            },
            playerBoard: {
                x: 1638.96,
                y: 785.8,
                scale: 1.5,
            },
            winsContainer: {
                x: 144.48,
                y: 588.8,
                scale: 1.3
            },
            score: {
                x: 144.48,
                y: 993.92,
                scale: 1,
            },
            cardSlot1: {
                x: 3260,
                y: 412,
                scale: 0.5,
                rotation: 0,
            },
            cardSlot2: {
                x: 3410,
                y: 412,
                scale: 0.5,
                rotation: 0,
            },
            cardSlot3: {
                x: 3560,
                y: 412,
                scale: 0.5,
                rotation: 0,
            },
            cardSlot4: {
                x: 3710,
                y: 412,
                scale: 0.5,
                rotation: 0,
            },
        },
        player: {
            namePanel: {
                x: 2540.28,
                y: 1221.36,
                scale: 1,
            },
            playerStats: {
                x: 3220,
                y: 1383.28,
                scale: 1,
                lineHeightScale: 1,
            },
            winsText: {
                x: 284.48,
                y: 1879.6,
                fontSize: 48,
            },
            playerBoard: {
                x: 1638.96,
                y: 1509.08,
                scale: 1.5,
            },
            winsContainer: {
                x: 144.48,
                y: 1736.4,
                scale: 1.3
            },
            score: {
                x: 144.48,
                y: 1326.04,
                scale: 1,
            },
            cardSlot1: {
                x: 3260,
                y: 1255.28,
                scale: 0.5,
            },
            cardSlot2: {
                x: 3410,
                y: 1255.28,
                scale: 0.5,
            },
            cardSlot3: {
                x: 3560,
                y: 1255.28,
                scale: 0.5,
            },
            cardSlot4: {
                x: 3710,
                y: 1255.28,
                scale: 0.5,
            },
        }
    },
    mobile: { //width: 2532, height: 1170
        scale: 0.59,
        cardScale: 0.475,

        potContainer: {
            x: 707,
            y: 87,
            scale: 0.53,
        },
        forfeitButton: {
            x: 555, // 195
            y: 87,
            scale: 0.66,
            fontSize: 52,
        },
        howToPlayButton: {
            x: 2337,
            y: 87,
            scale: 0.66,
            fontSize: 48,
        },
        standButton: {
            x: 822,
            y: 1095,
            scale: 0.5,
            fontSize: 40,
        },
        endTurnButton: {
            x: 1512,
            y: 1095,
            scale: 0.5,
            fontSize: 40,
        },
        turnTimer: {
            x: 1235, 
            y: 620,
            scale: 0.66,
            fontSize: 52.75,
        },
        statusMessage: {
            x: 997,
            y: 585,
            scale: 0.66,
        },
        spectatorCount: {
            x: 461.75,
            y: 160,
            scale: 0.52,
        },
        emojiMenu: {
            x: 2360,
            y: 1032,
            scale: 0.48,
        },
        winModal: {
            x: 1266,
            y: 585,
            scale: 0.55,
        },
        opponent: {
            namePanel: {
                x: 1714,
                y: 198,
                scale: 0.66,
            },
            chatIcon: {
                x: 1930,
                y: 190,
                scale: 0.15,
            },
            winsText: {
                x: 296.7,
                y: 168,
                fontSize: 38,
            },
            playerBoard: {
                x: 1108,
                y: 393,
                scale: 1,
            },
            winsContainer: {
                x: 146.7,
                y: 263,
                scale: 0.8
            },
            score: {
                x: 146.7,
                y: 517,
                scale: 0.65,
            },
            cardSlot1: {
                x: 1154,
                y: 202,
                scale: 0.33,
                rotation: Math.PI,
            },
            cardSlot2: {
                x: 1253,
                y: 202,
                scale: 0.33,
                rotation: Math.PI,
            },
            cardSlot3: {
                x: 1352,
                y: 202,
                scale: 0.33,
                rotation: Math.PI,
            },
            cardSlot4: {
                x: 1451,
                y: 202,
                scale: 0.33,
                rotation: Math.PI,
            },
        },
        player: {
            namePanel: {
                x: 1714,
                y: 661,
                scale: 0.66,
            },
            winsText: {
                x: 296.7,
                y: 1082,
                fontSize: 38,
            },
            playerBoard: {
                x: 1108,
                y: 856,
                scale: 1,
            },
            winsContainer: {
                x: 146.7,
                y: 983,
                scale: 0.8
            },
            score: {
                x: 146.7,
                y: 727,
                scale: 0.65,
            },
            cardSlot1: {
                x: 2097,
                y: 372,
                scale: 0.8,
            },
            cardSlot2: {
                x: 2347,
                y: 372,
                scale: 0.8,
            },
            cardSlot3: {
                x: 2097,
                y: 757,
                scale: 0.8,
            },
            cardSlot4: {
                x: 2347,
                y: 757,
                scale: 0.8,
            },
        }
    },
    mobileSpectator: { //width: 2532, height: 1170
        scale: 0.59,
        cardScale: 0.475,

        potContainer: {
            x: 1200,
            y: 87,
            scale: 0.53,
        },
        forfeitButton: {
            x: 195,
            y: 87,
            scale: 0.66,
            fontSize: 52,
        },
        howToPlayButton: {
            x: 548,
            y: 87,
            scale: 0.66,
            fontSize: 48,
        },
        turnTimer: {
            x: 1235, 
            y: 620,
            scale: 0.66,
            fontSize: 52.75,
        },
        statusMessage: {
            x: 997,
            y: 585,
            scale: 0.66,
        },
        playerStatsBackground: {
            x: 2240,
            y: 620,
            scaleX: 0.52,
            scaleY: 0.56,
        },
        spectatorCount: {
            x: 608,
            y: 1100,
            scale: 0.52,
        },
        emojiMenu: {
            x: 1880,
            y: 1095,
            scale: 0.48,
        },
        winModal: {
            x: 1266,
            y: 585,
            scale: 0.55,
        },
        opponent: {
            namePanel: {
                x: 1714,
                y: 198,
                scale: 0.66,
            },
            chatIcon: {
                x: 1930,
                y: 190,
                scale: 0.15,
            },
            playerStats: {
                x: 2030,
                y: 328,
                scale: 0.66,
                lineHeightScale: 0.8,
            },
            winsText: {
                x: 296.7,
                y: 168,
                fontSize: 38,
            },
            playerBoard: {
                x: 1108,
                y: 393,
                scale: 1,
            },
            winsContainer: {
                x: 146.7,
                y: 263,
                scale: 0.8
            },
            score: {
                x: 146.7,
                y: 517,
                scale: 0.65,
            },
            cardSlot1: {
                x: 2060,
                y: 238,
                scale: 0.4,
                rotation: 0,
            },
            cardSlot2: {
                x: 2180,
                y: 238,
                scale: 0.4,
                rotation: 0,
            },
            cardSlot3: {
                x: 2300,
                y: 238,
                scale: 0.4,
                rotation: 0,
            },
            cardSlot4: {
                x: 2420,
                y: 238,
                scale: 0.4,
                rotation: 0,
            },
        },
        player: {
            namePanel: {
                x: 1714,
                y: 661,
                scale: 0.66,
            },
            playerStats: {
                x: 2030,
                y: 791,
                scale: 0.66,
                lineHeightScale: 0.8,
            },
            winsText: {
                x: 296.7,
                y: 1082,
                fontSize: 38,
            },
            playerBoard: {
                x: 1108,
                y: 856,
                scale: 1,
            },
            winsContainer: {
                x: 146.7,
                y: 983,
                scale: 0.8
            },
            score: {
                x: 146.7,
                y: 727,
                scale: 0.65,
            },
            cardSlot1: {
                x: 2060,
                y: 701,
                scale: 0.4,
            },
            cardSlot2: {
                x: 2180,
                y: 701,
                scale: 0.4,
            },
            cardSlot3: {
                x: 2300,
                y: 701,
                scale: 0.4,
            },
            cardSlot4: {
                x: 2420,
                y: 701,
                scale: 0.4,
            },
        }
    }
}

export default componentCoordinates;